import { ActiveProductSetForCompanyResponse } from '@upright/common/model/input/blanket/product-weight-form';

export function generateCompanyInputFormLink(
  inputType: 'insights' | 'targets' | 'products',
  company: { id: string; name: string },
  productSetData?: ActiveProductSetForCompanyResponse,
) {
  if (inputType === 'insights') {
    return `/input/insights/${company.id}/${company.name}`;
  }

  if (inputType === 'targets') {
    return `/input/targets/${company.id}/${company.name}`;
  }

  return productSetData?.accessToken
    ? `/input/products/${company.id}/${productSetData.accessToken.productSetId}-${productSetData.accessToken.signature}/`
    : null;
}
